'use strict';

var React = require('react');
var HTMLVisualElement = require('../html/HTMLVisualElement.cjs');
var SVGVisualElement = require('../svg/SVGVisualElement.cjs');
var isSvgComponent = require('./utils/is-svg-component.cjs');

const createDomVisualElement = (Component, options) => {
    return isSvgComponent.isSVGComponent(Component)
        ? new SVGVisualElement.SVGVisualElement(options)
        : new HTMLVisualElement.HTMLVisualElement(options, {
            allowProjection: Component !== React.Fragment,
        });
};

exports.createDomVisualElement = createDomVisualElement;
//# sourceMappingURL=create-visual-element.cjs.map
